"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _httpActions = require("../actions/http-actions");

var _optimizeActions = require("../actions/optimize-actions");

var _util = require("./util");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  experimentsByKey: {},
  featuresByKey: {}
};
exports.initialState = initialState;
var optimizeReducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2["default"])(_handleActions, "".concat(_optimizeActions.POST_OPTIMIZE_ACTIVATE, "_").concat(_httpActions.REQUEST), function _() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var key = action.meta.experimentKey;
  var value = state.experimentsByKey[key] || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    experimentsByKey: _objectSpread(_objectSpread({}, state.experimentsByKey), {}, (0, _defineProperty2["default"])({}, key, _objectSpread(_objectSpread({}, value), {}, {
      isReady: false
    })))
  });
}), (0, _defineProperty2["default"])(_handleActions, "".concat(_optimizeActions.POST_OPTIMIZE_ACTIVATE, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var key = action.meta.experimentKey;
  var value = state.experimentsByKey[key] || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    experimentsByKey: _objectSpread(_objectSpread({}, state.experimentsByKey), {}, (0, _defineProperty2["default"])({}, key, _objectSpread(_objectSpread({}, value), {}, {
      variation: action.payload.result,
      isReady: true
    })))
  });
}), (0, _defineProperty2["default"])(_handleActions, "".concat(_optimizeActions.ENABLED_FEATURE, "_").concat(_httpActions.REQUEST), function _() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var featureKey = action.meta.featureKey;
  var key = featureKey[0];
  var value = state.featuresByKey[key] || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    featuresByKey: _objectSpread(_objectSpread({}, state.featuresByKey), {}, (0, _defineProperty2["default"])({}, key, _objectSpread(_objectSpread({}, value), {}, {
      isReady: false
    })))
  });
}), (0, _defineProperty2["default"])(_handleActions, "".concat(_optimizeActions.ENABLED_FEATURE, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var _action$payload = action.payload,
      key = _action$payload.key,
      variables = _action$payload.variables,
      enabled = _action$payload.enabled;
  return _objectSpread(_objectSpread({}, state), {}, {
    featuresByKey: _objectSpread(_objectSpread({}, state.featuresByKey), {}, (0, _defineProperty2["default"])({}, key, {
      variables: variables,
      enabled: enabled,
      isReady: true
    }))
  });
}), (0, _defineProperty2["default"])(_handleActions, "".concat(_optimizeActions.ENABLED_FEATURES, "_").concat(_httpActions.REQUEST), function _() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return _objectSpread(_objectSpread({}, state), {}, {
    featuresByKey: initialState.featuresByKey
  });
}), (0, _defineProperty2["default"])(_handleActions, "".concat(_optimizeActions.ENABLED_FEATURES, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var featuresByKey = {};
  action.payload.forEach(function (feature) {
    return featuresByKey[feature.key] = {
      variables: feature.variables,
      enabled: feature.enabled,
      isReady: true
    };
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    featuresByKey: featuresByKey
  });
}), (0, _defineProperty2["default"])(_handleActions, _optimizeActions.OPTIMIZE_SESSION_TIMEOUT, function (state, action) {
  var value = state.experimentsByKey[action.payload] || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    experimentsByKey: _objectSpread(_objectSpread({}, state.experimentsByKey), {}, (0, _defineProperty2["default"])({}, action.payload, _objectSpread(_objectSpread({}, value), {}, {
      variation: 'fallback',
      isReady: true
    })))
  });
}), (0, _defineProperty2["default"])(_handleActions, "".concat(_optimizeActions.POST_OPTIMIZE_ACTIVATE, "_").concat(_httpActions.FAILURE), function _(state, action) {
  var key = action.meta.experimentKey;
  var value = state.experimentsByKey[key] || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    experimentsByKey: _objectSpread(_objectSpread({}, state.experimentsByKey), {}, (0, _defineProperty2["default"])({}, key, _objectSpread(_objectSpread({}, value), {}, {
      variation: 'fallback',
      isReady: true
    }))),
    error: (0, _util.payloadError)(action)
  });
}), _handleActions), initialState);
var _default = optimizeReducer;
exports["default"] = _default;